import axios from "axios";
import { toast } from "react-toastify";
import { clearAuthTokens, getAuthToken, getRefreshToken, setAuthTokens } from "../utils/AuthToken";
import { BASE_API_URL } from "../config";

export const api = axios.create({
  baseURL: BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) throw new Error("No refresh token");

  const response = await axios.post(`/auth/refresh/`, {
    refresh_token: refresh,
  });

  const { access_token, refresh_token } = response.data;
  setAuthTokens(access_token, refresh_token);
  return access_token;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      toast.error("ارتباط با سرور برقرار نیست");
      return Promise.reject(error);
    }
    // change 403 related to expired token to 401
    if (
      error.response?.status === 403 &&
      error.response?.data?.detail?.includes("expired")
    ) {
      error.response.status = 401;
    }
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {

        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = "Bearer " + token;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshAccessToken();
        processQueue(null, newToken);
        originalRequest.headers.Authorization = "Bearer " + newToken;
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        clearAuthTokens();
        toast.info("نشست شما منقضی شده است. لطفاً دوباره وارد شوید.");
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    const status = error.response?.status;
    if ([401, 403, 500].includes(status)) {
      const msg =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        "خطایی رخ داده است";
      toast.error(msg);
    }

    return Promise.reject(error);
  }
);
